import { useDispatch, useSelector } from "react-redux";
import { setAccessAC, getAccessSettings } from "@entities";
import "./kh-access.scss";

import { Text, CheckBox } from "@ui-kit";

const KHAccess = () => {
  const dispatch = useDispatch();
  const settings = useSelector(getAccessSettings);

  const { services = [], campaigns = [], roles = [] } = settings;

  // Универсальный обработчик для типов патреона
  const handleTierChange = (campaignId, tierId, service) => {
    const newSettings = {
      ...settings,
      campaigns: settings.campaigns.map((campaign) => {
        if (campaign.id !== campaignId) return campaign;

        // 2. Копируем нужную кампанию
        return {
          ...campaign,
          tiers: campaign.tiers.map((tier) => {
            if (tier.id !== tierId) return tier;

            // 3. Копируем нужный тир и его объект access
            return {
              ...tier,
              access: {
                ...tier.access,
                [service]: !tier.access[service],
              },
            };
          }),
        };
      }),
    };

    dispatch(setAccessAC(newSettings));
  };

  // Обработчик для ролей и субролей
  const handleRoleChange = (roleName, subRoleName, service) => {
    const newSettings = {
      ...settings,
      roles: settings.roles.map((role) => {
        // Если это не та роль, которую мы меняем — возвращаем как есть
        if (role.name !== roleName) return role;

        // Если меняем СУБРОЛЬ
        if (subRoleName) {
          return {
            ...role,
            subRoles: role.subRoles.map((sr) => {
              if (sr.name !== subRoleName) return sr;
              return {
                ...sr,
                access: {
                  ...sr.access,
                  [service]: !sr.access[service],
                },
              };
            }),
          };
        }

        // Если меняем саму РОЛЬ
        return {
          ...role,
          access: {
            ...role.access,
            [service]: !role.access[service],
          },
        };
      }),
    };

    dispatch(setAccessAC(newSettings));
  };

  return (
    <div className="kh-access">
      <div className="kh-access__header mb-24">
        <Text as="h5" className="subtitle mb-12">
          Access settings in the plugin for different groups.
        </Text>
      </div>
      <div className="kh-access__content">
        <div className="table">
          <div className="table-header">
            <div className="header__name">
              <Text as="h5">Name</Text>
            </div>
            <div className="header__subname">
              <Text as="h5">Sub Name</Text>
            </div>

            {services.map((service) => (
              <div className={`header__${service}`} key={service}>
                <Text as="h5">{service.toUpperCase()}</Text>
              </div>
            ))}
          </div>

          <div className="table__body">
            <div className="table__title">
              <div className="cell__name">
                <Text as="h5">Campaigns</Text>
              </div>
            </div>
            {campaigns?.map((campaign, index) => (
              <div
                key={`campaign-${campaign.id}-${index}`}
                className="table__part"
              >
                <div className="table__row">
                  <div className="cell__name">
                    <Text as="h6">{campaign.name}</Text>
                  </div>
                </div>

                {campaign?.tiers?.map((tier) => (
                  <div key={`tier-${tier.id}`} className={`table__row${tier?.published ? '' : ' unpublished'}`}>
                    <div className="cell__name"></div>
                    <div className="cell__subname">
                      <Text as="h6">{tier.title}</Text>
                    </div>
                    {services.map((service) => (
                      <div
                        key={`tier-${tier.id}-${service}`}
                        className={`cell__${service}`}
                      >
                        <CheckBox
                          key={service}
                          className="checkbox__item"
                          size="sm"
                          checked={tier.access[service] || false}
                          onChange={() =>
                            handleTierChange(campaign.id, tier.id, service)
                          }
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}

            <div className="table__title">
              <div className="cell__name">
                <Text as="h5">Roles</Text>
              </div>
            </div>
            {roles?.map((role, index) => (
              <div key={`role-${role.name}-${index}`} className="table__part">
                <div className="table__row">
                  <div className="cell__name">
                    <Text as="h6">{role.name}</Text>
                  </div>

                  <div className="cell__subname"></div>

                  {services.map((service) => (
                    <div
                      key={`role-${role.name}-${service}`}
                      className={`cell__${service}`}
                    >
                      <CheckBox
                        key={service}
                        checked={role.access[service]}
                        size="sm"
                        onChange={() =>
                          handleRoleChange(role.name, null, service)
                        }
                      />
                    </div>
                  ))}
                </div>

                {role?.subRoles?.map((subRole) => (
                  <div className="table__row">
                    <div className="cell__name"></div>
                    <div className="cell__subname">
                      <Text as="h6">{subRole.name}</Text>
                    </div>

                    {services.map((service) => (
                      <div
                        key={`subRole-${subRole.name}-${service}`}
                        className={`cell__${service}`}
                      >
                        <CheckBox
                          key={service}
                          checked={subRole.access[service]}
                          size="sm"
                          onChange={() =>
                            handleRoleChange(role.name, subRole.name, service)
                          }
                        />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KHAccess;
